export const BRAND = {
  gradient: "linear-gradient(135deg, #F97316 0%, #EC4899 50%, #8B5CF6 100%)",
  orange: "#F97316",
  pink: "#EC4899",
  purple: "#8B5CF6",
  dark: "#0F0F1E",
  white: "#FFFFFF",
  gray: "#94A3B8",
};

export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

export function GradText({ children, style }) {
  return (
    <span
      style={{
        background: BRAND.gradient,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        ...style,
      }}
    >
      {children}
    </span>
  );
}

export function Section({ children, style, innerRef }) {
  return (
    <section
      ref={innerRef}
      style={{
        minHeight: "100vh",
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "56px 44px",
        position: "relative",
        scrollSnapAlign: "start",
        ...style,
      }}
    >
      {children}
    </section>
  );
}
